import React, { PureComponent } from 'react';
import { SimpleForm } from 'react-admin';
import { reduxForm } from 'redux-form';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import { TextField } from '@mui/material';

const SanitizedGrid = (props) => {
  return <Grid {...props} />;
};

class CircuitModal extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      nameError: null,
      restFor: 0,
      restForError: null,
    };
  }

  componentDidMount = () => {
    const { circuit } = this.props;
    if (circuit) {
      const { id, name, restFor } = circuit;
      this.setState({
        circuitId: id,
        name: name || '',
        nameError: null,
        restFor: restFor || 0,
        restForError: null,
      });
    }
  };

  onSubmit = () => {
    const { addCircuit, updateCircuit, circuit } = this.props;
    const { circuitId, name, restFor } = this.state;

    if (!this.validate('name', name) || !(restFor || restFor == '0')) {
      return false;
    }
    const values = { name };

    values.restFor = parseInt(restFor);
    if (circuitId) {
      updateCircuit(circuitId, Object.assign(circuit, values));
    } else {
      addCircuit(values);
    }
    this.close();
  };

  getNumericValue(event) {
    return event.target.value.replace(/[^0-9]/g, '');
  }

  close = () => {
    const { handleClose } = this.props;
    handleClose();
  };

  handleNameChange = (event) => {
    this.handleChange('name', event.target.value);
  };

  handleRestForChange = (event) => {
    const restFor = this.getNumericValue(event);
    this.handleChange('restFor', restFor);
  };

  handleChange = (name, value) => {
    this.validate(name, value);
  };

  validate = (name, value) => {
    let error = null;
    if (!value) {
      error = 'Required';
    }
    this.setState({
      [name]: value,
      [`${name}Error`]: error,
    });
    return !error;
  };

  render() {
    const { open } = this.props;
    const { name, nameError, restFor, restForError } = this.state;
    const { handleSubmit } = this.props;
    const fullWidth = {
      width: '100%',
    };
    return (
      <Dialog
        open={open}
        onClose={this.close}
        fullWidth
        maxWidth="md"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Add Circuit</DialogTitle>
        <DialogContent>
          <SimpleForm
            variant="standard"
            id="circuit-form"
            form="circuit-create"
            margin="normal"
            onSubmit={handleSubmit(this.onSubmit)}
            toolbar={null}
          >
            <SanitizedGrid container spacing={1} style={fullWidth}>
              <Grid size={{ xs: 12 }}>
                <TextField
                  label="Name"
                  name="name"
                  required
                  value={name}
                  onChange={this.handleNameChange}
                  autoFocus
                  fullWidth
                  error={!!nameError}
                  helperText={nameError}
                />
              </Grid>
              <Grid size={{ xs: 12 }}>
                <TextField
                  label="Rest for"
                  name="restFor"
                  value={restFor}
                  onChange={this.handleRestForChange}
                  required
                  fullWidth
                  error={!!restForError}
                  helperText={restForError}
                />
              </Grid>
            </SanitizedGrid>
          </SimpleForm>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.close}>Cancel</Button>
          <Button
            variant="contained"
            type="submit"
            form="circuit-form"
            onClick={handleSubmit(this.onSubmit)}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

// eslint-disable-next-line no-class-assign
CircuitModal = reduxForm({
  form: 'circuit-form',
})(CircuitModal);

export default CircuitModal;
